import { createContext } from 'react';

export type ScrollContextProps = {
  scrollPosition: {
    x: number;
    y: number;
  };
  isScrolling: boolean;
};

export const ScrollContext = createContext<ScrollContextProps>({
  /** the x and y position of the container ref */
  scrollPosition: {
    x: 0,
    y: 0,
  },
  /** while container is scrolling - isScrolling is true */
  isScrolling: false,
});
// set a name for react-component devtools
ScrollContext['displayName'] = 'ScrollContext';
